import CustomerItem, {
  CustomerType,
} from '../../../../../models/helperTypes/CustomerItem';
import ClientFormData from '../../../../../models/helperTypes/ClientFormData';

export function modifiedCustomerItem(
  originalData: CustomerItem,
  formData: ClientFormData,
): CustomerItem {
  const emptyCustomer = !formData.driverAndCustomerAreDifferent;

  return {
    type: formData.type as CustomerType,
    entityName: formData.entityName,
    sendEmailCreatorUser: formData.sendEmailCreatorUser,

    birthday: formData.birthday,
    firstName: formData.firstName,
    lastName: formData.lastName,
    gender: formData.gender,
    email: formData.email,
    phoneNumber: formData.phoneNumber,

    // Variables to modify (driver)
    driverAndCustomerAreDifferent: formData.driverAndCustomerAreDifferent,
    driverFirstName: emptyCustomer ? '' : formData.driverFirstName,
    driverLastName: emptyCustomer ? '' : formData.driverLastName,
    driverBirthday: emptyCustomer ? '' : formData.driverBirthday,
    driverGender: emptyCustomer ? '' : formData.driverGender,
    driverIdNumber: emptyCustomer ? '' : formData.driverIdNumber,
    driverIdType: emptyCustomer ? '' : formData.driverIdType,

    // Variables to keep
    id: originalData.id,
    transitZone: originalData.transitZone,
    transitTime: originalData.transitTime,
    collisionsQty: originalData.collisionsQty,
    exonerationQty: originalData.exonerationQty,
    offensesQty: originalData.offensesQty,
    alcoholBreath: originalData.alcoholBreath,
  };
}

export const cleanFormData = (data: ClientFormData): ClientFormData => {
  const customerFormData = data;
  customerFormData.firstName = data.firstName.trim();
  customerFormData.lastName = data.lastName.trim();
  customerFormData.gender = data.gender || 'M';
  customerFormData.birthday = data.birthday || '01/01/2000';
  return customerFormData;
};
